<template>
  <div id="home-right" ref="appRef">
    <div class="d-flex">
      <div class="top-left">
        <dv-border-box-10 :color="['#1b60cc', '#17caf0']">
          <div class="nums-box">
            <div class="num-item">
              <div class="num" style="color: #e6cf4e">{{ scaleTotal }}</div>
              <div class="num-title">评量工具-使用次数</div>
            </div>
            <div class="num-item">
              <div class="num" style="color: #f36c6c">{{ IEPTotal }}</div>
              <div class="num-title">IEP制定-总数</div>
            </div>
            <div class="num-item">
              <div class="num" style="color: #20d180">{{ planTotal }}</div>
              <div class="num-title">教案-总数</div>
            </div>
          </div>
        </dv-border-box-10>
      </div>
      <div class="top-right">
        <dv-border-box-13 :color="['#1b60cc', '#17caf0']">
          <ToolsRank :rankData="toolRank" />
        </dv-border-box-13>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-left">
        <h3>资源文件上传数量统计</h3>
        <BottomLeftChart :cdata="fileData" />
      </div>
      <div class="bottom-right">
        <dv-border-box-13 :color="['#1b60cc', '#17caf0']">
          <h3>热门课程资源</h3>
          <HotCourseRank :rankData="resourceRank" />
        </dv-border-box-13>
      </div>
    </div>
    <div class="backBtn">
      <dv-border-box-10 :color="['#1b60cc', '#17caf0']">
        <h4 @click="btnBack">返回平台</h4>
      </dv-border-box-10>
    </div>
  </div>
</template>

<script>
// import drawMixin from '@/utils/drawMixin';
import ToolsRank from '_c/ranks/toolsRank.vue';
import HotCourseRank from '_c/ranks/hotCourseRank.vue';
import BottomLeftChart from '_c/echart/right/bottomLeft/chart.vue';

import {
  getScaleTotal,
  getIEPTotal,
  getPlanTotal,
  getScaleRank,
  getFileNums,
  getResourceRank
} from '@/api/right.js';

export default {
  // mixins: [drawMixin],
  components: {
    ToolsRank,
    HotCourseRank,
    BottomLeftChart
  },
  data() {
    return {
      scaleTotal: 0,
      IEPTotal: 0,
      planTotal: 0,
      toolRank: [
        // ['培智课程评量', '556', '1'],
        // ['学生学习特点调查表', '344', '2'],
        // ['班级学生行为量表', '234', '3']
      ],
      resourceRank: [
        // ['文件1', '556', '1'],
        // ['文件2', '344', '2'],
        // ['文件3', '234', '3']
      ],
      fileData: {
        xAxisData: [
          '评估资源',
          '课程资源',
          '特色课程',
          '教学具/辅具资源',
          '常用表格'
        ],
        seriesData: []
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.getScalelNum();
      this.getIEPlNum();
      this.getPlanNum();
      this.getResourceFileNums();
      this.getToolsRank();
      this.getResourceRank();
    },
    // 工具总数
    async getScalelNum() {
      const { data } = await getScaleTotal();
      this.scaleTotal = data.count + '';
    },
    // iep总数
    async getIEPlNum() {
      const { data } = await getIEPTotal();
      this.IEPTotal = data.count + '';
    },
    // 教案总数
    async getPlanNum() {
      const { data } = await getPlanTotal();
      this.planTotal = data.count + '';
    },
    // 资源文件数量
    async getResourceFileNums() {
      const { data } = await getFileNums();
      if (!Array.isArray(data)) return;
      // let typeMap = {
      //   CommonTables: '常用表格',
      //   Assessment: '评估资源',
      //   Course: '课程资源',
      //   SpecialCourse: '特色课程',
      //   TeacherResource: '教学具/辅具'
      // };
      let sortArr = [
        'Assessment',
        'Course',
        'SpecialCourse',
        'TeacherResource',
        'CommonTables'
      ];
      this.fileData.seriesData = sortArr.map((type) => {
        let item = data.find((item) => item.type === type);
        if (item) {
          return item.count;
        } else {
          return 0;
        }
      });
    },
    // 工具排行
    async getToolsRank() {
      const { data } = await getScaleRank();
      if (!Array.isArray(data)) return;
      this.toolRank = data.map((item) => {
        return [item.type, item.count, item.rank];
      });
    },
    // 热门课程资源排行
    async getResourceRank() {
      const { data } = await getResourceRank();
      if (!Array.isArray(data)) return;
      this.resourceRank = data.map((item) => {
        return [item.type, item.count, item.rank];
      });
    },

    btnBack() {
      // this.$router.go(-1);
      const token = localStorage.getItem('token');
      // 根据env配置动态跳转
      window.location.href = `${process.env.VUE_APP_BASE_URL}/login?token=${token}`;
    }
  }
};
</script>

<style lang="scss" scoped>
#home-right {
  width: 1920px;
  height: 1080px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;
  // background-color: #0a1531;
  overflow: hidden;
  color: #fff;
  padding-left: 24px;
  padding-top: 90px;
  .top-left {
    width: 50%;
    margin-right: 24px;
    // border: 2px solid #1b60cc;
    // border-radius: 20px;
  }
  .nums-box {
    height: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .num-item {
      width: 33.3%;
      text-align: center;
      .num {
        padding: 20px;
        font-size: 60px;
        color: #17caf0;
      }
      .num-title {
        font-size: 24px;
      }
    }
  }
  .top-right {
    width: 878px;
    // border: 2px solid #1b60cc;
    // border-radius: 20px;
  }
  .bottom {
    display: flex;
    margin-top: 40px;
    width: 1845px;
    h3 {
      width: 100%;
      padding-top: 40px;
      font-size: 29px;
      line-height: 29px;
      font-weight: 400;
      color: #17caf0;
      text-align: center;
    }
    .bottom-left {
      width: 945px;
      height: 495px;
      background-image: url(~@/assets/images/right-bottom-border2.png);
      background-size: 100% 100%;
    }
    .bottom-right {
      flex: 1;
      height: 495px;
      margin-left: 30px;
    }
  }

  .backBtn {
    position: fixed;
    top: 30px;
    right: 30px;
    h4 {
      padding: 10px 30px;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
</style>
